import React from 'react';
import { Text } from '..';

const NoData = function(props: Props) {
  return (
    <div className="w-100">
      <Text
        size="md"
        type="p"
        className="h-3 shadow-sm radius-sm d-flex justify-content-center align-items-center w-100 "
        color="yellow"
      >
        table.noItemFound
      </Text>
    </div>
  );
};

export default NoData;
